@file:OptIn(ExperimentalSerializationApi::class)
package com.gsb.vyapar.bhagya.domain

import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class Message(
    val data: Map<String, String> = mapOf()
)

fun String.toMessage(): Message {
    return ProtoBuf.decodeFromByteArray<Message>(this.decodeBase64Bytes().uncompress(GZIP))
}

fun Message.toMessageString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}

fun getEmailMessage(requestId: String, to: String, subject: String, message: String): Message {
    return Message(
        mapOf(
            REQUESTID to requestId,
            MESSAGE_TYPE to EMAIL,
            TO to to,
            SUBJECT to subject,
            MESSAGE to message
        )
    )
}

fun Message.getRequestId(): String {
    return this.data[REQUESTID].orEmpty()
}

fun Message.getTo(): String {
    return this.data[TO].orEmpty()
}

fun Message.getSubject(): String {
    return this.data[SUBJECT].orEmpty()
}

fun Message.getMessage(): String {
    return this.data[MESSAGE].orEmpty()
}

fun Message.isEmailMessage(): Boolean {
    return this.data[MESSAGE_TYPE] == EMAIL
}

fun getMobileMessage(requestId: String, to: String, message: String): Message {
    return Message(
        mapOf(
            REQUESTID to requestId,
            MESSAGE_TYPE to MOBILE,
            TO to to,
            MESSAGE to message
        )
    )
}

fun Message.isMobileMessage(): Boolean {
    return this.data[MESSAGE_TYPE] == MOBILE
}

fun getSuccessMessage(requestId: String): Message {
    return Message(
        mapOf(
            REQUESTID to requestId,
            MESSAGE_TYPE to ACKNOWLEDGE,
            RESULT to SUCCESS,
        )
    )
}

fun Message.isSuccessMessage(requestId: String): Boolean {
    return checkAckTypeAndReqId(this, requestId) && this.data[RESULT] == SUCCESS
}

fun getFailureMessage(requestId: String, reason: String): Message {
    return Message(
        mapOf(
            REQUESTID to requestId,
            MESSAGE_TYPE to ACKNOWLEDGE,
            RESULT to reason,
        )
    )
}

fun Message.isFailureMessage(requestId: String): Boolean {
    return checkAckTypeAndReqId(this, requestId) && this.data[RESULT] != SUCCESS
}

fun Message.failureReason(requestId: String): String? {
    return this.data[RESULT]
}

fun checkAckTypeAndReqId(message: Message, requestId: String): Boolean {
    return message.data[MESSAGE_TYPE] == ACKNOWLEDGE && message.data[REQUESTID] == requestId
}